import { Typography } from '@chargeafter/ui';
import { Box, Paper, styled } from '@mui/material';
import { FC } from 'react';
import { PaperLayoutProps } from './MainPaperLayout';

const StyledPaper = styled(Paper)(({ theme }) => ({
  //TODO: Replace with general styled paper and add additional styling
  minHeight: `calc(100vh - 100px - 80px - 48px - 10vw)`, //100-topbar, 32-footer, 80-header,100-padding, 10vw button
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

const StyledFlatHeader = styled(Typography)(({ theme }) => ({
  fontWeight: 'bold',
  margin: theme.spacing(4),
  textAlign: 'center',
  color: theme.palette.primary.main,
}));

export const SecondaryPaperLayout: FC<PaperLayoutProps> = ({
  header,
  content,
  actionArea,
}) => {
  return (
    <StyledPaper>
      <StyledFlatHeader variant="h1" data-testid="page-header">
        {header}
      </StyledFlatHeader>
      <Box data-testid="page-content">{content}</Box>
      <Box width="100%">{actionArea}</Box>
    </StyledPaper>
  );
};
